export default "__VITE_ASSET__BWxyGzyk__"